module.exports = __webpack_public_path__ + "static/img/pk-img1.c861800.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/pk-img1.png
// module id = bi7H
// module chunks = 1